//
//
//
//
//
//

  export default {
    name: "index",
    mounted() {
      // let url = window.location.href;
      // this.$routerHelper.saveQueryParams.call(this,url)
      
      //?appid=mylink&thirdPartyToken=5a084543-d706-436d-bc07-c4b25b810864
      //?appid=h5
      //http://localhost:8080/#/?appid=mylink&thirdPartyToken=2a64ea94-2697-4acf-bd0d-eb414de9277b
      let appId = localStorage.getItem('appId')
      if(appId){
        this.$routerHelper.goPageByThird('home')
      }
    },
    methods: {
    },
  };
  


// WEBPACK FOOTER //
// ./src/pages/index.vue